<template>
  <div class="box13">
    <pageTitle title="常见问题" text />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "大家都来学前端，市场会不会饱和啊?",
          answer: [
            "目前各大招聘网站都有上万职位在招聘前端工程师，在整个市场来看，就算人数数量再多，都不会影响前端开发的需求量。饱和的只是低端饱和，高端始终缺人。",
          ],
        },
        {
          title: "尊享无忧班是怎么保证学习效率的呢?",
          answer: [
            "1. 老师会给定制专属个性化学习计划，带你快速学习就业课程；",
            "2. 对于课程的重难点、课程类型（比如了解、掌握、应用等）会告诉你哪些可以倍速学习。",
          ],
        },
        {
          title: "课程要学习多长时间?",
          answer: [
            "我们会给每个学员制定高效的学习计划，提升学习效率，缩短学习周期，在保证效果的前提下大概需要6个月左右可就业。",
          ],
        },
        {
          title: "师资怎么样?",
          answer: [
            "前端学科教研团队拥有120多位专业的老师，其中有多位是全球开源项目Vue代码的贡献者，而且都是专职研发老师。",
          ],
        },
        {
          title: "没有基础可以学会嘛?",
          answer: ["可以学习，课程内容和服务项目，是专门为0基础同学设计的。"],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/web/box13/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("HTML&JS+前端-就业课","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/web/box13/bgc.png") no-repeat;
  background-size: cover;
  .box {
    margin-top: 48px;
  }
  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(129deg, #0ccb84 0%, #25ceed 100%);
    box-shadow: 0px 4px 12px 0px rgba(64, 255, 189, 0.12);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
